import type { ReactNode } from 'react';

export interface DetailPanelProps {
  title: ReactNode;
  subtitle?: ReactNode;
  count?: ReactNode;
  actions?: ReactNode;
  /** Vises i statuslinjen nederst. */
  status?: ReactNode;
  statusRight?: ReactNode;
  /** Fjern padding i indholdet (fx til tabeller, der fylder hele panelet). */
  flush?: boolean;
  children: ReactNode;
}

/** Hoejre detaljepanel med gradient-sidehoved og statuslinje (som hbplanner). */
export function DetailPanel({
  title,
  subtitle,
  count,
  actions,
  status,
  statusRight,
  flush,
  children,
}: DetailPanelProps) {
  return (
    <div className="detail-panel">
      <div className="section-header">
        <div>
          <h3>{title}</h3>
          {subtitle !== undefined && <div className="section-subtitle">{subtitle}</div>}
        </div>
        <div className="header-actions">
          {count !== undefined && <span className="count-badge">{count}</span>}
          {actions}
        </div>
      </div>
      <div className={`detail-content${flush ? ' flush' : ''}`}>{children}</div>
      {(status !== undefined || statusRight !== undefined) && (
        <div className="status-bar">
          <span>{status}</span>
          <span>{statusRight}</span>
        </div>
      )}
    </div>
  );
}
